const isTrue = value => value === true || value === 1 || value === '1' || value === 'true'

export const canCopyPageRoutePrompt = project => (
    project?.accessType === 'INTERNAL' && isTrue(project?.isOwner)
)

export const canOpenPortalVibeProject = project => isTrue(project?.hasPageRoute)

export const getPortalVibeOpenDisabledReason = project => (
    canOpenPortalVibeProject(project) ? '' : '该应用仅提供接口服务，暂无可打开的页面'
)
